import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HealthStatusResponse } from '../models/health-status.model';

/**
 * Consome o endpoint público `GET /api/health/status` (somente leitura do cache do backend).
 * Em caso de erro HTTP, retorna um estado `Unknown` em vez de propagar a exceção — o
 * indicador nunca deve quebrar a aplicação.
 */
@Injectable({
  providedIn: 'root'
})
export class HealthService {
  private readonly statusUrl = `${environment.apiUrl}/health/status`;

  constructor(private readonly http: HttpClient) { }

  getStatus(): Observable<HealthStatusResponse> {
    return this.http.get<HealthStatusResponse>(this.statusUrl).pipe(
      catchError(() => of(HealthService.unknownResponse()))
    );
  }

  /** Estado padrão exibido quando o backend está inacessível ou ainda não respondeu. */
  static unknownResponse(): HealthStatusResponse {
    return {
      status: 'Unknown',
      message: 'Não foi possível obter o estado de saúde dos serviços.',
      checkedAt: null,
      nextCheckAt: null,
      services: []
    };
  }
}
